import React from 'react';

import Exact from './exact';

import {
  CreateConfigFn,
  nonAuthenticatedRedirect,
  pathJoin,
} from '../../../../routing/utils';

import { Roles } from '../../../../routing/child-router-factory';

import DownloadCalendar from './download';

import { TicketView } from '../../../shared/views/ticket/Ticket';

export type Keys = `exact` | ':ticketId' | 'download';

export const createRoutesMap = (prefix: string) => ({
  download: pathJoin(prefix)(`download`).chain,
  ':ticketId': (containerId: string) => pathJoin(prefix)(containerId).chain,
});

const authenticatedUser: Roles = {
  and: ['authenticated'],
};

export const createConfig: CreateConfigFn<Keys> = (map) => [
  {
    key: 'download',
    fallback: (roles) => nonAuthenticatedRedirect(map)(roles),
    roles: authenticatedUser,
    children: <DownloadCalendar />,
    path: map.app.collections.download._,
  },
  {
    key: ':ticketId',
    fallback: (roles) => nonAuthenticatedRedirect(map)(roles),
    roles: authenticatedUser,
    children: <TicketView />,
    path: map.app.collections[':ticketId'](':ticketId')._,
  },
  {
    key: 'exact',
    fallback: (roles) => nonAuthenticatedRedirect(map)(roles),
    roles: authenticatedUser,
    children: <Exact />,
    path: map.app.collections._,
    exact: true,
  },
];
